/**
 * Series colours for charts and diagrams.
 *
 * The Okabe–Ito palette: eight colours chosen to stay distinguishable under the common
 * forms of colour-vision deficiency, which matters for a chart pasted into a paper that
 * a marker may read in greyscale or with deuteranopia. Hex values rather than theme
 * tokens because an exported SVG or PNG has no stylesheet — it must carry its colours.
 * Black is last so it is used only when the first seven run out.
 */
export const CHART_COLORS = [
  "#0072B2",
  "#E69F00",
  "#009E73",
  "#D55E00",
  "#56B4E9",
  "#CC79A7",
  "#F0E442",
  "#000000",
] as const;

/** Ink and rules for exported graphics, which are always drawn on white. */
export const CHART_INK = {
  text: "#1f1f1f",
  muted: "#5f5f5f",
  grid: "#e2e2e2",
  axis: "#8a8a8a",
  background: "#ffffff",
} as const;

export function seriesColor(index: number): string {
  return CHART_COLORS[index % CHART_COLORS.length];
}
